import React, { useRef, useState, useEffect } from 'react';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';
 

const Editor = () => {
  const [editor, setEditor] = useState(null);
  const monacoEl = useRef(null);

  useEffect(() => {
    if (monacoEl.current) {
      setEditor((editor) => {
        if (editor) return editor;
        return monaco.editor.create(monacoEl.current, {
          value: ['function x() {', '\tconsole.log("Hello world!");', '}'].join('\n'),
          language: 'typescript'
        });
      });
    }

    return () => editor?.dispose(); 
  },  // eslint-disable-next-line 
  [monacoEl.current]);

  return <div className='editor-outline' style={{height:"50vh",width:"100%",border:"0",outline:"0px"}} ref={monacoEl}></div>;
};

export default Editor;